export default {
  pt_br: {
    bannerImg: 'id.png',
    umText: 'Available Soon',
    requiredLogin: 'Faça login para jogar',
  },
};
